import React, { Suspense } from 'react';
import type { ReactNode } from 'react';
import PageLayout from './PageLayout';

interface PageProps {
  topbar?: ReactNode;
  children: React.ReactNode;
}

const Page = ({ topbar, children }: PageProps) => {
  return (
    <>
      {topbar}
      <PageLayout.Inner>
        <Suspense fallback={null}>{children}</Suspense>
      </PageLayout.Inner>
    </>
  );
};

export default Page;
